//#region imports
import { createSlice, createAsyncThunk, createSelector } from "@reduxjs/toolkit";
import * as TimelineService from "_services/timeline-service";

import { createDuplicates, getDate, getHalfHourInterval, searchTasks, getFlightTime, createCombinedBookings, createArrivalBookingsList, createCombinedRampBookings, processBookingsToTempList, processMissingBookingsTimes, formatDuplicatedBoardings, groupAndFormatALTPickupTasks, sortJobsByAssistance, formatFlightListFromBookings, deriveFlightIdFromTask, getTimeString, roundDownToHour } from "_utils/functions";

import { SaudiDomesticAirports } from "_utils/timeline-constants";
//#endregion imports

// Round a date/time down to the nearest 5 minutes and return "HH:MM"
const roundToNearest5String = (date) => {
  const d = new Date(date);
  if (Number.isNaN(d.getTime())) return null;
  const minutes = d.getMinutes();
  const rounded = Math.floor(minutes / 5) * 5;
  d.setMinutes(rounded);
  const hh = String(d.getHours()).padStart(2, "0");
  const mm = String(d.getMinutes()).padStart(2, "0");
  return `${hh}:${mm}`;
};

//#region initial state
let initalTimelineObject = {
  columns: {
    "00:00": { id: "00:00", jobs: [] },
    "01:00": { id: "01:00", jobs: [] },
    "02:00": { id: "02:00", jobs: [] },
    "03:00": { id: "03:00", jobs: [] },
    "04:00": { id: "04:00", jobs: [] },
    "05:00": { id: "05:00", jobs: [] },
    "06:00": { id: "06:00", jobs: [] },
    "07:00": { id: "07:00", jobs: [] },
    "08:00": { id: "08:00", jobs: [] },
    "09:00": { id: "09:00", jobs: [] },
    "10:00": { id: "10:00", jobs: [] },
    "11:00": { id: "11:00", jobs: [] },
    "12:00": { id: "12:00", jobs: [] },
    "13:00": { id: "13:00", jobs: [] },
    "14:00": { id: "14:00", jobs: [] },
    "15:00": { id: "15:00", jobs: [] },
    "16:00": { id: "16:00", jobs: [] },
    "17:00": { id: "17:00", jobs: [] },
    "18:00": { id: "18:00", jobs: [] },
    "19:00": { id: "19:00", jobs: [] },
    "20:00": { id: "20:00", jobs: [] },
    "21:00": { id: "21:00", jobs: [] },
    "22:00": { id: "22:00", jobs: [] },
    "23:00": { id: "23:00", jobs: [] },
  },
  columnIds: [
    "00:00",
    "01:00",
    "02:00",
    "03:00",
    "04:00",
    "05:00",
    "06:00",
    "07:00",
    "08:00",
    "09:00",
    "10:00",
    "11:00",
    "12:00",
    "13:00",
    "14:00",
    "15:00",
    "16:00",
    "17:00",
    "18:00",
    "19:00",
    "20:00",
    "21:00",
    "22:00",
    "23:00",
  ],
};

let inital30MinTimelineObject = {
  columns: {
    "00:00": { id: "00:00", jobs: [] },
    "00:30": { id: "00:30", jobs: [] },
    "01:00": { id: "01:00", jobs: [] },
    "01:30": { id: "01:30", jobs: [] },
    "02:00": { id: "02:00", jobs: [] },
    "02:30": { id: "02:30", jobs: [] },
    "03:00": { id: "03:00", jobs: [] },
    "03:30": { id: "03:30", jobs: [] },
    "04:00": { id: "04:00", jobs: [] },
    "04:30": { id: "04:30", jobs: [] },
    "05:00": { id: "05:00", jobs: [] },
    "05:30": { id: "05:30", jobs: [] },
    "06:00": { id: "06:00", jobs: [] },
    "06:30": { id: "06:30", jobs: [] },
    "07:00": { id: "07:00", jobs: [] },
    "07:30": { id: "07:30", jobs: [] },
    "08:00": { id: "08:00", jobs: [] },
    "08:30": { id: "08:30", jobs: [] },
    "09:00": { id: "09:00", jobs: [] },
    "09:30": { id: "09:30", jobs: [] },
    "10:00": { id: "10:00", jobs: [] },
    "10:30": { id: "10:30", jobs: [] },
    "11:00": { id: "11:00", jobs: [] },
    "11:30": { id: "11:30", jobs: [] },
    "12:00": { id: "12:00", jobs: [] },
    "12:30": { id: "12:30", jobs: [] },
    "13:00": { id: "13:00", jobs: [] },
    "13:30": { id: "13:30", jobs: [] },
    "14:00": { id: "14:00", jobs: [] },
    "14:30": { id: "14:30", jobs: [] },
    "15:00": { id: "15:00", jobs: [] },
    "15:30": { id: "15:30", jobs: [] },
    "16:00": { id: "16:00", jobs: [] },
    "16:30": { id: "16:30", jobs: [] },
    "17:00": { id: "17:00", jobs: [] },
    "17:30": { id: "17:30", jobs: [] },
    "18:00": { id: "18:00", jobs: [] },
    "18:30": { id: "18:30", jobs: [] },
    "19:00": { id: "19:00", jobs: [] },
    "19:30": { id: "19:30", jobs: [] },
    "20:00": { id: "20:00", jobs: [] },
    "20:30": { id: "20:30", jobs: [] },
    "21:00": { id: "21:00", jobs: [] },
    "21:30": { id: "21:30", jobs: [] },
    "22:00": { id: "22:00", jobs: [] },
    "22:30": { id: "22:30", jobs: [] },
    "23:00": { id: "23:00", jobs: [] },
    "23:30": { id: "23:30", jobs: [] },
  },
  columnIds: [
    "00:00", "00:30", "01:00", "01:30", "02:00", "02:30",
    "03:00", "03:30", "04:00", "04:30", "05:00", "05:30",
    "06:00", "06:30", "07:00", "07:30", "08:00", "08:30",
    "09:00", "09:30", "10:00", "10:30", "11:00", "11:30",
    "12:00", "12:30", "13:00", "13:30", "14:00", "14:30",
    "15:00", "15:30", "16:00", "16:30", "17:00", "17:30",
    "18:00", "18:30", "19:00", "19:30", "20:00", "20:30",
    "21:00", "21:30", "22:00", "22:30", "23:00", "23:30"
  ],
};

//#endregion initial state

//#region async functions

export const setBookingLocation = createAsyncThunk(
  "employees/setBookingLocation",
  async (params) => {
    return TimelineService.setBookingLocation(params);
  }
);

export const toggleCheckInPause = createAsyncThunk(
  "employees/toggleCheckInPause",
  async (params) => {
    const response = await TimelineService.toggleCheckInPause(params);
    return { ...response, bookingId: params.bookingId, pauseAction: params.action };
  }
);

export const getBookings = createAsyncThunk(
  "employees/getBookings",
  async (params) => {
    return TimelineService.getBookings(params);
  }
);

export const getTaskList = createAsyncThunk(
  "employees/getTaskList",
  async (iata) => {
    return TimelineService.getTaskList(iata);
  }
);

export const createTask = createAsyncThunk(
  "employees/createTask",
  async (task) => {
    return TimelineService.createTask(task);
  }
);

export const updateTask = createAsyncThunk(
  "employees/updateTask",
  async (task, anynmous) => {
    return TimelineService.updateTask(task, anynmous);
  }
);

export const unplanTask = createAsyncThunk(
  "employees/unplanTask",
  async (params) => {
    return TimelineService.unplanTask(params);
  }
);

export const acceptUnplannedTask = createAsyncThunk(
  "employees/acceptUnplannedTask",
  async (task) => {
    return TimelineService.acceptUnplannedTask(task);
  }
);

export const getDepartureBookings = createAsyncThunk(
  "employees/getDepartureBookings",
  async (params) => {
    return TimelineService.getBookings(params);
  }
);

export const paxCheckIn = createAsyncThunk(
  "employees/paxCheckIn",
  async (params) => {
    return TimelineService.paxCheckIn(params);
  }
);

export const arrivalPaxCheckIn = createAsyncThunk(
  "employees/arrivalPaxCheckIn",
  async (params) => {
    return TimelineService.arrivalPaxCheckIn(params?.bookingId, params?.body);
  }
);

export const paxCheckOut = createAsyncThunk(
  "employees/paxCheckOut",
  async (params) => {
    return TimelineService.paxCheckOut(params);
  }
);

// post bookingsList
export const postBookingList = createAsyncThunk('bookings/postBookingList', async (params) => {
  //console.log('posting booking list in slice...', params)
  return TimelineService.postBookings(params);
});

// deleteBooking
export const deleteBooking = createAsyncThunk('employees/deleteBooking', async (params) => {
  return TimelineService.deleteBooking(params);
});

// unRejectPax
export const unRejectPax = createAsyncThunk('employees/unRejectPax', async (params) => {
  return TimelineService.unRejectPax(params);
});

export const getPreAdvisedAndWalkups = createAsyncThunk('employees/getPreAdvisedAndWalkups', async (params) => {
  return TimelineService.getPreAdvisedAndWalkups(params);
});

export const selectPassengers = createAsyncThunk('employees/selectPassengers', async (params) => {
  return TimelineService.selectPassengers(params);
});

// deleteTimelineJobs
export const deleteTimelineJob = createAsyncThunk('employees/deleteTimelineJob', async (params) => {
  return TimelineService.deleteTimelineJob(params);
});


export const saveEmployeeShift = createAsyncThunk('timelineData/saveEmployeeShift', async (props) => {
  return TimelineService.saveEmployeeShiftService(props);
});

export const getComparisonReportData = createAsyncThunk('timelineData/getComparisonReportData', async (props) => {
  return TimelineService.getComparisonReportService(props);
});
export const getProductivityReportData = createAsyncThunk('timelineData/getProductivityReportData', async (props) => {
  return TimelineService.getProductivityReportService(props);
});
export const getStaffShiftsReportData = createAsyncThunk('timelineData/getStaffShiftsReportData', async (props) => {
  return TimelineService.getStaffShiftsReportService(props);
});

export const getDeviceReportData = createAsyncThunk('timelineData/getDeviceReportData', async (props) => {
  return TimelineService.getDeviceReportService(props);
});

export const getSessionReportData = createAsyncThunk('timelineData/getSessionReportData', async (props) => {
  return TimelineService.getSessionReportService(props);
});

//#endregion async functions

const initialState = {
  areas: [],

  bookingSearch: "", // search term for booking
  bookingSearchFilter: 'flight',      // search filter using passenger name by default

  // data object used to render timeline
  timelineCache: initalTimelineObject, // holds previous state of timeline
  timelineData: initalTimelineObject,

  thirtyMinTimelineCache: inital30MinTimelineObject, // holds previous state of timeline
  thirtyMinTimelineData: inital30MinTimelineObject,
  newestJob: null, // holds newest job to be added to timeline

  // booking flags
  bookings: [],
  bookingStatus: "idle",
  bookingError: null,

  // departure booking flags
  departureBookings: [],
  departureBookingStatus: "idle",
  departureBookingError: null,
  duplicatedCombinedBookings: [],

  // array of the ramp combined bookings duplications
  duplicatedCombinedRampBookings: [],

  // array of the departure bookings duplications
  duplicatedDeparturesBookings: [],

  // array of the arrivals bookings duplications
  duplicatedArrivalsBookings: [],

  // task list
  taskList: [],
  // task indexes for fast lookup
  tasksById: {},
  tasksByTime: {},
  tasksByEmployeeSlot: {},

  taskStatus: "idle",
  taskError: null,
  arrivalsTaskList: [],
  departuresTaskList: [],

  // create task
  createdTask: null,
  createTaskStatus: "idle",
  createTaskError: null,

  // unplan task
  unplanTaskStatus: "idle",
  unplanTaskError: null,

  status: "idle",
  error: null,

  // accept unplanned task
  acceptUnplanedTaskStatus: "idle",
  acceptUnplanedTaskError: null,

  //  flighta type filter (international, domestic, all)
  flightsType: "all",

  // update task flags
  updateTaskStatus: "idle",
  updateTaskError: null,

  // booking by flight number 
  bookingByFlightNum: null,

  // break task list
  breakTaskList: [],

  // adhoc task list
  adhocTaskList: [],

  // passenger check in flags
  paxCheckInStatus: "idle",
  paxCheckInError: null,

  // passenger check out flags
  paxCheckOutStatus: "idle",
  paxCheckOutError: null,

  // arrival pax check in flags
  arrivalPaxCheckInStatus: "idle",
  arrivalPaxCheckInError: null,

  // set bookings location flags
  setBookingLocationStatus: "idle",
  setBookingLocationError: null,

  // check-in pause flags
  toggleCheckInPauseStatus: "idle",
  toggleCheckInPauseError: null,
  checkInPausedBookings: {},

  bookingList: [],
  bookingListStatus: 'idle',
  postBookingListError: null,
  additionalPassengers: [{
    firstName: "",
    secondName: "",
    assistance: []
  }],

  // delete booking flags
  deleteBookingStatus: "idle",
  deleteBookingError: null,

  // unReject PAX flags
  unRejectPaxStatus: "idle",
  unRejectPaxError: null,

  // pre-advised and non-pre-advised(Walkups) analytics
  preAdvisedAndWalkups: null,
  getPreAdvisedAndWalkupsStatus: "idle",
  getPreAdvisedAndWalkupsError: null,
  preAdvisedAndWalkupsReportData: [],


  // select passengers flags
  selectPassengersStatus: "idle",
  selectPassengersError: null,

  // task status filter 
  taskStatusFilter: "all",


  deleteTimelineJobStatus: "idle",
  deleteTimelineJobError: null,

  showAddPassenger: null,
};

const timelineDataSlice = createSlice({
  name: "timelineData",
  initialState,
  reducers: {
    reset: (state) => initialState,
    setTimelineData: (state, action) => {
      state.newestJob = action?.payload?.job;
    },
    setBookingSearch: (state, action) => {
      state.bookingSearch = action.payload;
    },
    setBookingSearchFilter: (state, action) => {
      state.bookingSearchFilter = action.payload;
    },
    resetTimelineData: (state, action) => {
      state.timelineData = initalTimelineObject;// holds previous state of timeline
      state.thirtyMinTimelineData = inital30MinTimelineObject;
      state.newestJob = null;
    },
    resetBookings: (state, action) => {
      state.bookings = [];
      state.departureBookings = [];
      state.departureBookingStatus = "idle";
      state.departureBookingError = null;
      state.flightsType = "all";
    },
    clearCreateTaskStatus: (state, action) => {
      state.createTaskStatus = "idle";
      state.createTaskError = null;
    },
    setTimelineCache: (state, action) => {
      state.timelineData = action.payload;
    },
    // setTimelineJobs: (state, action) => {
    //   state.tasklist = action.payload;
    // },
    resetDeleteFlags: (state, action) => {
      state.unplanTaskStatus = "idle";
      state.unplanTaskError = null;
    },
    resetTimelineToCache: (state, action) => {
      state.timelineData = state.timelineCache;
    },
    updateTaskList: (state, action) => {
      const payload = action?.payload;
      const tasks = Array.isFullArray(payload) ? payload : Array.isFullArray(payload?.tasks) ? payload.tasks : [];
      const flightSlotLookup = !Array.isArray(payload) ? payload?.flightSlotLookup : null;
      const userIata = !Array.isArray(payload) ? payload?.userIata || "" : "";
      const thirtyMinLayoutFlag = !Array.isArray(payload)
        ? payload?.thirtyMinLayout
        : undefined;

      // update task list with new list of tasks
      state.taskList = tasks;

      // reset task indexes
      state.tasksById = {};
      state.tasksByTime = {};
      state.tasksByEmployeeSlot = {};

      // for each task
      for (const task of tasks) {

        // check task is valid
        if (!task || !task._id || !task?.employeeId) {
          continue;
        }



        // store each task by id
        state.tasksById[task._id] = task;

        // derive slot key using live flight time when available
        let slot = null;
        const isThirtyMinLayout = typeof thirtyMinLayoutFlag === "boolean"
          ? thirtyMinLayoutFlag
          : state.timelineControl?.thirtyMinLayout;

        if (!isThirtyMinLayout) {
          // hour layout uses hour buckets based on assigned time
          slot = roundDownToHour(task?.assignedTime);
        }
        else {
          // 30-min layout uses rounded-down HH:MM buckets

          // Break tasks: use placementTime if available (rounded to 30-min interval)
          if (task?.isBreakTask && task?.placementTime) {
            slot = task.placementTime;
          }
          // ALT pickups have special slot logic: startTime → pickUpTime → assignedTime
          else if (task?.isALTPickUp) {
            const taskHasStarted = !!task?.startTime;
            const shouldUseTaskStart = taskHasStarted || task?.active || task?.completed;

            // 1. If started/active/completed, use startTime
            if (shouldUseTaskStart && task?.startTime) {
              const { seconds, nanoseconds, _seconds, _nanoseconds } = task.startTime;
              if (typeof seconds === "number" || typeof _seconds === "number") {
                const ms =
                  (seconds ?? _seconds) * 1000 +
                  ((nanoseconds ?? _nanoseconds ?? 0) / 1_000_000);
                slot = roundToNearest5String(new Date(ms)) || getTimeString(new Date(ms));
              } else {
                slot = roundToNearest5String(task.startTime) || getTimeString(task.startTime);
              }
            }

            // 2. If only assigned, use pickUpTime
            if (!slot && task?.pickUpTime) {
              const { seconds, _seconds } = task.pickUpTime;
              const secs = seconds ?? _seconds;
              if (typeof secs === 'number') {
                const date = new Date(secs * 1000);
                slot = roundToNearest5String(date) || getTimeString(date);
              }
            }

            // 3. Fallback to assignedTime
            if (!slot && task?.assignedTime) {
              const assigned = `${task.assignedTime}:00`;
              slot = roundToNearest5String(assigned) || task?.assignedTime;
            }
          }
          // Regular tasks: startTime → (departure: assignedTime) → (arrival: flightSlotLookup) → assignedTime
          else {
            const flightId = deriveFlightIdFromTask(task, userIata);

            // use actual task start time when the task has started/active/completed
            const taskHasStarted = !!task?.startTime;
            const shouldUseTaskStart = taskHasStarted || task?.active || task?.completed;

            if (shouldUseTaskStart && task?.startTime) {
              // startTime is often a Firestore timestamp; normalize to Date first
              const { seconds, nanoseconds, _seconds, _nanoseconds } = task.startTime;
              if (typeof seconds === "number" || typeof _seconds === "number") {
                const ms =
                  (seconds ?? _seconds) * 1000 +
                  ((nanoseconds ?? _nanoseconds ?? 0) / 1_000_000);
                slot = roundToNearest5String(new Date(ms)) || getTimeString(new Date(ms));
              } else {
                slot = roundToNearest5String(task.startTime) || getTimeString(task.startTime);
              }
            }

            // For departure tasks (not started), use assignedTime (the slot the job was placed on)
            const isDepartureTask = task?.flightInformation?.departureAirport === userIata;
            if (!slot && isDepartureTask && task?.assignedTime) {
              const assigned = `${task.assignedTime}:00`;
              slot = roundToNearest5String(assigned) || task?.assignedTime;
            }

            // For arrival tasks (or if no slot yet), try flight slot lookup
            if (!slot && flightId && flightSlotLookup?.[flightId]) {
              slot = flightSlotLookup[flightId];
            }

            // Fallback to assignedTime (rounded down to 5)
            if (!slot) {
              const assigned = task?.assignedTime
                ? `${task.assignedTime}:00`
                : null;
              slot = roundToNearest5String(assigned) || task?.assignedTime;
            }
          }
        }

        // store task by time slot
        if (!state.tasksByTime[slot]) {
          state.tasksByTime[slot] = [];
        }

        // push task id to time slot
        state.tasksByTime[slot].push(task._id);

        // index by employee + time slot
        const employeeId = task?.employeeId;

        // check employee slot object exists
        if (employeeId) {
          if (!state.tasksByEmployeeSlot[employeeId]) {
            state.tasksByEmployeeSlot[employeeId] = {};
          }
          if (!state.tasksByEmployeeSlot[employeeId][slot]) {
            state.tasksByEmployeeSlot[employeeId][slot] = [];
          }
          state.tasksByEmployeeSlot[employeeId][slot].push(task._id);
        }

      }
    },
    updateArrivalsTaskList: (state, action) => {
      state.arrivalsTaskList = action.payload;
    },
    updateDeparturesTaskList: (state, action) => {
      state.departuresTaskList = action.payload;
    },
    setFlightsTypeFilter: (state, action) => {
      state.flightsType = action.payload;
    },
    resetUpdateTaskFlags: (state) => {
      state.updateTaskStatus = "idle";
      state.updateTaskError = null;
    },
    getBookingByFlightNum: (state, action) => {
      let tempBookingList = [...state?.bookings, ...state?.departureBookings];
      let selectedBooking = tempBookingList?.filter((row) => `${row?.doc?.flightConfirmationDetails
        ?.carrierCode}${row?.doc?.flightConfirmationDetails
          ?.flightNumber}` == action.payload)
      state.bookingByFlightNum = selectedBooking
    },
    resetBookingByFlightNum: (state) => {
      state.bookingByFlightNum == null
    },
    updateBreakTaskList: (state, action) => {
      state.breakTaskList = action.payload;
    },
    updateAdhocTaskList: (state, action) => {
      state.adhocTaskList = action.payload;
    },
    resetPaxCheckInFlags: (state) => {
      state.paxCheckInStatus = "idle";
      state.paxCheckInError = null;
    },
    resetPaxCheckOutFlags: (state) => {
      state.paxCheckOutStatus = "idle";
      state.paxCheckOutError = null;
    },
    resetArrivalPaxCheckInFlags: (state) => {
      state.arrivalPaxCheckInStatus = "idle";
      state.arrivalPaxCheckInError = null;
    },
    resetSetBookingLocationFlags: (state) => {
      state.setBookingLocationStatus = "idle";
      state.setBookingLocationError = null;
    },
    resetToggleCheckInPauseFlags: (state) => {
      state.toggleCheckInPauseStatus = "idle";
      state.toggleCheckInPauseError = null;
    },

    setAdditionalPassengers: (state, action) => {
      return {
        ...state,
        additionalPassengers: action.payload
      }
    },
    resetAdditionalPassengers: (state) => {
      return {
        ...state,
        bookingListStatus: 'idle',
        bookingList: [],
        postBookingListError: null,
      }
    },

    updateTimeLineDepartureBookings: (state, action) => {
      state.departureBookings = action.payload
    },
    updateTimeLineArrivalsBookings: (state, action) => {
      state.bookings = action.payload
    },
    setDuplicatedCombinedBookings: (state, action) => {
      state.duplicatedCombinedBookings = action.payload
    },

    setDuplicatedCombinedRampBookings: (state, action) => {
      state.duplicatedCombinedRampBookings = action.payload
    },
    setDuplicatedDepartureBookings: (state, action) => {
      state.duplicatedDeparturesBookings = action.payload
    },
    setDuplicatedArrivalsBookings: (state, action) => {
      state.duplicatedArrivalsBookings = action.payload
    },

    resetDeleteBookingFlags: (state) => {
      state.deleteBookingStatus = "idle";
      state.deleteBookingError = null;
    },

    resetUnRejectPaxFlags: (state) => {
      state.unRejectPaxStatus = "idle";
      state.unRejectPaxError = null;
    },
    resetGetPreAdvisedAndWalkupsStatus: (state) => {
      state.getPreAdvisedAndWalkupsStatus = "idle";
      state.getPreAdvisedAndWalkupsError = null;
    },
    resetGetPreAdvisedAndWalkups: (state) => {
      state.preAdvisedAndWalkups = null;
      state.getPreAdvisedAndWalkupsStatus = "idle";
      state.getPreAdvisedAndWalkupsError = null;
      state.preAdvisedAndWalkupsReportData = []
    },
    setPreAdvisedAndWalkupsReportData: (state, action) => {
      state.preAdvisedAndWalkupsReportData = action.payload
    },
    resetSelectPassengersFlags: (state) => {
      state.selectPassengersStatus = "idle";
      state.selectPassengersError = null;
    },

    setTaskStatusFilter: (state, action) => {
      state.taskStatusFilter = action.payload;
    },

    resetDeleteTimelineJobFlags: (state) => {
      state.deleteTimelineJobStatus = "idle";
      state.deleteTimelineJobError = null;
    },

    setShowAddPassenger: (state, action) => {
      state.showAddPassenger = action.payload;
    },

  },
  extraReducers: {
    [unplanTask.pending]: (state, action) => {
      state.unplanTaskStatus = "loading";
    },
    [unplanTask.fulfilled]: (state, action) => {
      state.unplanTaskStatus = "succeeded";
      // task list update and remove the deleted task
      const taskId = action.payload["_id"];
      state.taskList = state.taskList.filter(task => task["_id"] !== taskId);
      state.breakTaskList = state.breakTaskList.filter(task => task["_id"] !== taskId);

      // Handling timeline data update
      const timelineData = { ...state.timelineData };
      const columns = { ...timelineData.columns };
      const columnIds = [...timelineData.columnIds];
      columnIds.forEach(columnId => {
        const jobs = columns[columnId].jobs.filter(job => job["_id"] !== taskId);
        columns[columnId].jobs = jobs;
      });

      timelineData.columns = columns;
      state.timelineData = timelineData;
    },
    [unplanTask.rejected]: (state, action) => {
      state.unplanTaskStatus = "failed";
      state.bookingError = action.error.message;
    },
    [getBookings.pending]: (state, action) => {
      state.bookingStatus = "loading";
    },
    [getBookings.fulfilled]: (state, action) => {
      state.bookingStatus = "succeeded";
      state.bookings = action.payload;
    },
    [getBookings.rejected]: (state, action) => {
      state.bookingStatus = "failed";
      state.bookingError = action.error.message;
    },
    [getDepartureBookings.pending]: (state, action) => {
      state.departureBookingStatus = "loading";
    },
    [getDepartureBookings.fulfilled]: (state, action) => {
      state.departureBookingStatus = "succeeded";
      state.departureBookings = action.payload;
    },
    [getDepartureBookings.rejected]: (state, action) => {
      state.departureBookingStatus = "failed";
      state.departureBookingError = action.error.message;
    },
    [getTaskList.pending]: (state, action) => {
      state.taskStatus = "loading";
      state.allTaskStatus = "loading";
    },
    [getTaskList.fulfilled]: (state, action) => {
      state.taskStatus = "succeeded";
      state.taskList = action.payload;
      state.allTaskStatus = "succeeded";
      state.allTaskList = action.payload;
    },
    [getTaskList.rejected]: (state, action) => {
      state.taskStatus = "failed";
      state.taskError = action.error.message;
      state.allTaskStatus = "failed";
      state.allTaskError = action.error.message;
    },
    [createTask.pending]: (state, action) => {
      state.createTaskStatus = "loading";
    },
    [createTask.fulfilled]: (state, action) => {
      state.createTaskStatus = "succeeded";
      state.createdTask = action.payload;
    },
    [createTask.rejected]: (state, action) => {
      state.createTaskStatus = "failed";
      state.createTaskError = action.error.message;
    },
    [updateTask.pending]: (state, action) => {
      state.updateTaskStatus = "loading";
    },
    [updateTask.fulfilled]: (state, action) => {
      state.updateTaskStatus = "succeeded";
      // check if task has isALTPickUp and the employeeId is null then this task is updated with unplan task so remove it from state.timelineData
      if (action?.payload?.isALTPickUp == true && action?.payload?.employeeId == null) {
        // task list update and remove the deleted task
        const taskId = action.payload["_id"];
        // Handling timeline data update
        const timelineData = { ...state.timelineData };
        const columns = { ...timelineData.columns };
        const columnIds = [...timelineData.columnIds];
        columnIds.forEach(columnId => {
          const jobs = columns[columnId].jobs.filter(job => job["_id"] !== taskId);
          columns[columnId].jobs = jobs;
        });

        timelineData.columns = columns;
        state.timelineData = timelineData;
      }

    },
    [updateTask.rejected]: (state, action) => {
      state.updateTaskStatus = "failed";
      state.updateTaskError = action.error.message;
    },
    [acceptUnplannedTask.pending]: (state, action) => {
      state.acceptUnplanedTaskStatus = "loading";
    },
    [acceptUnplannedTask.fulfilled]: (state, action) => {
      state.acceptUnplanedTaskStatus = "succeeded";
    },
    [acceptUnplannedTask.rejected]: (state, action) => {
      state.acceptUnplanedTaskStatus = "failed";
      state.acceptUnplanedTaskError = action.error.message;
    },
    [paxCheckIn.pending]: (state, action) => {
      state.paxCheckInStatus = "loading";
    },
    [paxCheckIn.fulfilled]: (state, action) => {
      state.paxCheckInStatus = "succeeded";
    },
    [paxCheckIn.rejected]: (state, action) => {
      state.paxCheckInStatus = "failed";
      state.paxCheckInError = action.error.message;
    },

    [paxCheckOut.pending]: (state, action) => {
      state.paxCheckOutStatus = "loading";
    },
    [paxCheckOut.fulfilled]: (state, action) => {
      state.paxCheckOutStatus = "succeeded";
    },
    [paxCheckOut.rejected]: (state, action) => {
      state.paxCheckOutStatus = "failed";
      state.paxCheckOutError = action.error.message;
    },

    [arrivalPaxCheckIn.pending]: (state, action) => {
      state.arrivalPaxCheckInStatus = "loading";
    },
    [arrivalPaxCheckIn.fulfilled]: (state, action) => {
      state.arrivalPaxCheckInStatus = "succeeded";
    },
    [arrivalPaxCheckIn.rejected]: (state, action) => {
      state.arrivalPaxCheckInStatus = "failed";
      state.arrivalPaxCheckInError = action.error.message;
    },

    [setBookingLocation.pending]: (state, action) => {
      state.setBookingLocationStatus = "loading";
    },
    [setBookingLocation.fulfilled]: (state, action) => {
      state.setBookingLocationStatus = "succeeded";
    },
    [setBookingLocation.rejected]: (state, action) => {
      state.setBookingLocationStatus = "failed";
      state.setBookingLocationError = action.error.message;
    },

    [toggleCheckInPause.pending]: (state) => {
      state.toggleCheckInPauseStatus = "loading";
    },
    [toggleCheckInPause.fulfilled]: (state, action) => {
      state.toggleCheckInPauseStatus = "succeeded";
      const { bookingId, checkInPause } = action.payload || {};
      if (bookingId) {
        const lastResumeEntry = [...(checkInPause?.history || [])].reverse().find(e => e.action === 'resume');
        state.checkInPausedBookings[bookingId] = {
          pausedAt: checkInPause?.pausedAt || null,
          shiftedCheckInTime: lastResumeEntry?.newCheckInTime || null,
        };
      }
    },
    [toggleCheckInPause.rejected]: (state, action) => {
      state.toggleCheckInPauseStatus = "failed";
      state.toggleCheckInPauseError = action.error.message;
    },

    [postBookingList.pending]: (state, action) => {
      return {
        ...state,
        bookingListStatus: 'loading'
      }
    },
    [postBookingList.fulfilled]: (state, action) => {
      if (action.payload.type) {
        if (action.payload.type == 'arrival') {
          // need to store response with arrival bookings
          let temp = [...state.bookings];



          // format and add each booking to the list
          action.payload.response.forEach((booking) => {
            let formattedBooking = {
              id: booking.id,
              _id: booking.id,
              doc: { ...booking, '_id': booking.id }
            }
            temp.push(formattedBooking);
          })

          return {
            ...state,
            bookingListStatus: 'succeeded',
            bookings: temp,
          }
        }
        else {
          // need to store response with departure bookings
          let temp = [...state.departureBookings];
          // format and add each booking to the list
          action.payload.response.forEach((booking) => {
            let formattedBooking = {
              id: booking.id,
              _id: booking.id,
              doc: { ...booking, '_id': booking.id }
            }
            temp.push(formattedBooking);
          })
          //console.log('new temp', temp)
          return {
            ...state,
            bookingListStatus: 'succeeded',
            departureBookings: temp,
          }
        }
      } else {
        return {
          ...state,
          bookingListStatus: 'failed',
          postBookingListError: action.payload?.response?.[0]?.error,
        }
      }
    },
    [postBookingList.rejected]: (state, action) => {

      return {
        ...state,
        bookingListStatus: 'failed',
        postBookingListError: action.error.message,
      }
    },

    [deleteBooking.pending]: (state, action) => {
      state.deleteBookingStatus = "loading";
    },
    [deleteBooking.fulfilled]: (state, action) => {
      state.deleteBookingStatus = "succeeded";
    },
    [deleteBooking.rejected]: (state, action) => {
      state.deleteBookingStatus = "failed";
      state.deleteBookingError = action.error.message;
    },

    [unRejectPax.pending]: (state) => {
      state.unRejectPaxStatus = "loading";
    },
    [unRejectPax.fulfilled]: (state) => {
      state.unRejectPaxStatus = "succeeded";
    },
    [unRejectPax.rejected]: (state, action) => {
      state.unRejectPaxStatus = "failed";
      state.unRejectPaxError = action?.error?.message;
    },

    [getPreAdvisedAndWalkups.pending]: (state) => {
      state.getPreAdvisedAndWalkupsStatus = "loading";
    },
    [getPreAdvisedAndWalkups.fulfilled]: (state, action) => {
      state.getPreAdvisedAndWalkupsStatus = "succeeded";
      state.preAdvisedAndWalkups = action.payload;
    },
    [getPreAdvisedAndWalkups.rejected]: (state, action) => {
      state.getPreAdvisedAndWalkupsStatus = "failed";
      state.getPreAdvisedAndWalkupsError = action.error.message;
    },

    [selectPassengers.pending]: (state) => {
      state.selectPassengersStatus = "loading";
    },
    [selectPassengers.fulfilled]: (state) => {
      state.selectPassengersStatus = "succeeded";
    },
    [selectPassengers.rejected]: (state, action) => {
      state.selectPassengersStatus = "failed";
      state.selectPassengersError = action.error.message;
    },

    [deleteTimelineJob.pending]: (state) => {
      state.deleteTimelineJobStatus = "loading";
    },
    [deleteTimelineJob.fulfilled]: (state) => {
      state.deleteTimelineJobStatus = "succeeded";
    },
    [deleteTimelineJob.rejected]: (state, action) => {
      state.deleteTimelineJobStatus = "failed";
      state.deleteTimelineJobError = action.error.message;
    }
  },
});

// select task by employee id and column
export const selectTaskByEmployeeAndColumn = (employeeId, slot) =>
  createSelector(
    [
      (state) => state.timelineData.tasksByEmployeeSlot?.[employeeId]?.[slot] || [],
      (state) => state.timelineData.tasksById,
      (state) => state.timelineData.bookingSearch,
      (state) => state.timelineData.taskStatusFilter
    ],
    (taskIds, tasksById, bookingSearch, taskStatusFilter) => {

      // expand task ids into full objects
      let tasks = taskIds.map(id => tasksById[id]);



      return tasks;
    }
  );

// select tasks for a specific time slot
export const selectTasksForSlot = (slot) =>
  createSelector(
    [
      (state) => state.timelineData.tasksByTime[slot] || [],
      (state) => state.timelineData.tasksById,
    ],
    (taskIds, tasksById) => taskIds.map(id => tasksById[id])
  );

// simlpe selector to get all tasks
export const selectAllTasks = (state) => state.timelineData.taskList;

// timeline data selectors
export const selectTimelineDataIndexes = (state) => {
  return {
    tasksById: state.timelineData.tasksById,
    tasksByTime: state.timelineData.tasksByTime,
    tasksByEmployeeSlot: state.timelineData.tasksByEmployeeSlot
  }
}

// select tasks by id
export const selectTasksById = (state, taskId) => {
  return state.timelineData.tasksById[taskId] || [];
}

// select tasks by time slot
export const selectTasksByTimeSlot = (state, timeSlot) => {
  return state.timelineData.tasksByTime[timeSlot] || [];
}

// select tasks by employee slot
export const selectTasksByEmployeeSlot = (state, employeeId) => {
  return state.timelineData.tasksByEmployeeSlot[employeeId] || [];
}

// timeline time index
export const selectTimelineTimeIndex = (state) => state.timelineData?.timelineData?.columnIds;

export const selectUpdateTaskError = (state) => state.timelineData.updateTaskError;


export const selectTimelineDataRaw = (state) => {
  return state.timelineData.timelineData;
};


export const selectTimelineData = (state) => {
  if (state.timelineData.timelineData == undefined || state.timelineData.timelineData == null || state.timelineData.taskList == null) {

    return state.timelineControl.thirtyMinLayout ? inital30MinTimelineObject : initalTimelineObject;
  }

  let tasks = [...state.timelineData.taskList]; // list of tasks

  const iata = state.user.dbInfo.details.authority;


  // ---------- OLD DON'T DELETE THIS COMMENT ----------



  let flights = [];
  if (!Object.isObjectEmpty(state?.timelineFlightList?.flightsByTime) && ["PUJ", "DUB"].includes(iata)) {
    flights = Object.values(state?.timelineFlightList?.flightsByTime)?.flat();
  } else if (!["PUJ", "DUB"].includes(iata)) {
    let arrivalFlights = Array.isFullArray(state.flightInformationList.inboundFlights) ? state.flightInformationList.inboundFlights : [];
    let departureFlights = Array.isFullArray(state.flightInformationList.outboundFlights) ? state.flightInformationList.outboundFlights : [];
    flights = [...arrivalFlights, ...departureFlights];
  }




  // check if there is a selected timeline filter tasks that has flight number that is in the selected area gates and stands
  if (!Object.isObjectEmpty(state.timelineAreas.selectedTimeline) && Array.isFullArray(tasks) && Array.isFullArray(flights)) {
    const areaTasks = []; // list of tasks that has flight number that is in the selected area gates and stands

    const selectedArea = state.timelineAreas.selectedTimeline;
    let locationsList = Array.isFullArray(state.timelineAreas.airportLocations)
      ? state.timelineAreas.airportLocations?.filter((location) => typeof location?.timelineId === "string" ? location?.timelineId == selectedArea?._id : location?.timelineId?.includes(selectedArea?._id))
      : [];
    const areaGatesAndStands = [];  // list of gates and stands in the selected area
    locationsList?.forEach((location) => {
      if (location.gate != undefined && location.gate != '') {
        areaGatesAndStands.push(location.gate);
      }
      if (location.stand != undefined && location.stand != '') {
        areaGatesAndStands.push(location.stand);
      }
    });

    // loop through tasks and add the tasks that has flight number that is in the selected area gates and stands to the areaTasks list
    for (let i = 0; i < tasks?.length; i++) {
      let task = tasks[i];


      if (task?.isBreakTask || task?.isAdhocTask) areaTasks.push(task);
      else {
        const flight = flights?.find((flight) => flight?.flightNumber == task?.flightInformation?.flightNumber);
        if (flight && (areaGatesAndStands?.includes(flight?.gate?.trim()) || areaGatesAndStands?.includes(flight?.stand?.trim()))) {
          areaTasks.push(task);
        }
      }
    }


    tasks = Array.isFullArray(areaTasks) ? areaTasks : [];
  }

  // ---------- END OLD DON'T DELETE THIS COMMENT ----------

  // check for selected area and add tasks drop off or pick up locations that are in the selected area locations
  // if (!Object.isObjectEmpty(state.timelineAreas.selectedTimeline) && Array.isFullArray(tasks)) {

  //   const areaTasks = [];

  //   const selectedArea = state.timelineAreas.selectedTimeline;

  //   // get list of locations that are in the selected area
  //   const areaLocationsList = Array.isFullArray(state.timelineAreas.airportLocations)
  //     ? state.timelineAreas.airportLocations?.filter((location) => typeof location?.timelineId === "string" ? location?.timelineId == selectedArea?._id : location?.timelineId?.includes(selectedArea?._id))
  //     : [];

  //   // get list of locations ids that are in the selected area
  //   const locationsIDS = Array.isFullArray(areaLocationsList) ? areaLocationsList?.map((location) => location?._id) : [];

  //   // loop through tasks and add tasks that have drop off or pick up locations that are in the selected area locations
  //   tasks?.forEach((task) => {
  //     if (locationsIDS?.includes(task?.dropOffLocation?.id) || locationsIDS?.includes(task?.pickUpLocation?.id)) {
  //       areaTasks.push(task);
  //     }
  //   });

  //   tasks = Array.isFullArray(areaTasks) ? areaTasks : [];

  // }


  // copy timeline data
  let tempTimeline = state.timelineControl.thirtyMinLayout ? { ...state.timelineData.thirtyMinTimelineData } : { ...state.timelineData.timelineData };

  if (state.timelineData.bookingSearch !== "" || state.flightInformationList.searchedFlight) {
    tasks = tasks.filter(task => searchTasks(task, state.timelineData.bookingSearch, state.flightInformationList.searchedFlight))
  }

  // add each task to timeline
  tasks.forEach((task) => {

    let assignedTime = task.assignedTime; // column hour
    // check if thirtyMinLayout switch is turned off check each task assigned time if minutes are not zeros 00 covert them (ex. 12:35 => 12:00)
    if (!state.timelineControl.thirtyMinLayout && assignedTime?.split(":")?.[1] !== "00") {
      assignedTime = `${assignedTime?.split(":")?.[0]}:00`;
    }

    // convert assigned time into half an hour interval
    if (state.timelineControl.thirtyMinLayout) {
      assignedTime = getHalfHourInterval(assignedTime);
    };
    let newJobColumn = { ...tempTimeline.columns[assignedTime] }; // column object

    // check if task has been rejected 
    newJobColumn?.jobs?.map((row) => row["_id"])?.map((item) => {
      if (task["_id"].startsWith(item) && task["_id"]?.includes("_rejected_")) {
        newJobColumn = {
          ...newJobColumn,
          jobs: newJobColumn?.jobs?.filter((element) => element["_id"] !== item),
        };
      }
    });

    // check if job already exists in column job list
    if (!newJobColumn?.jobs?.some((job) => job["_id"] === task["_id"])) {
      // job has not been added to timeline, add it
      let newJob = { ...task };
      let tempJobList = Array.isFullArray(newJobColumn.jobs) ? [...newJobColumn.jobs] : [];
      tempJobList.push(newJob);
      newJobColumn.jobs = tempJobList;
    } else {
      // job exsists, need to update it
      let tempJobList = [...newJobColumn.jobs];
      let index = tempJobList.findIndex((job) => job["_id"] === task["_id"]);
      tempJobList[index] = task;
      newJobColumn.jobs = tempJobList;
    }


    // create a new timeline with the modification
    tempTimeline = {
      ...tempTimeline,
      columns: {
        ...tempTimeline.columns,
        [assignedTime]: newJobColumn,
      },
    };
  });

  return tempTimeline;
};

/*

export const selectTimelineData = (state) => {
  return state.timelineData.timelineData;
}

*/

export const selectAllAltPickupJobs = (state) => {
  if (state.timelineData.timelineData == undefined || state.timelineData.timelineData == null || state.timelineData.taskList == null) {
    return [];
  }

  let tasks = [...state.timelineData.taskList]; // list of tasks

  // get all alt pickup tasks that are not assigned to any employee
  let altPickupTasks = tasks.filter((task) => task.isALTPickUp == true && (task.employeeId == null || task.employeeId == undefined));

  return altPickupTasks;
}

// selects alternative pickup jobs that have not been assigned to any employee and need to be shown in the job list
// filtered by flight id to avoid rerendering the same alt pickup jobs for the same flight
export const selectAltPickupJobList = (flightNumber) => (state) => {
  if (state?.timelineData.timelineData == undefined || state.timelineData.timelineData == null || state.timelineData.taskList == null) {
    return [];
  }

  let tasks = [...state.timelineData.taskList]; // list of tasks

  // get all alt pickup tasks that are not assigned to any employee
  let altPickupTasks = tasks.filter((task) => task.isALTPickUp == true && !task.isGateRelocation && (task.employeeId == null || task.employeeId == undefined));

  //console.log('altPickupTasks', altPickupTasks);
  //console.log('altPickupTasks', altPickupTasks);
  //console.log('flightNumber', flightNumber); 

  // return alt pickup tasks filtered by flight number
  return altPickupTasks.filter((task) => task.flightInformation?.flightNumber == flightNumber);
}

// Helper to convert Firestore timestamp to time slot
// thirtyMinLayout: true = 30-min slots (16:00, 16:30), false = hour slots (16:00, 17:00)
const timestampToSlot = (timestamp, thirtyMinLayout) => {
  if (!timestamp) return null;
  const seconds = timestamp.seconds ?? timestamp._seconds;
  if (typeof seconds !== 'number') return null;

  const date = new Date(seconds * 1000);
  const hours = date.getHours().toString().padStart(2, '0');

  if (thirtyMinLayout) {
    // 30-min layout: round to nearest 30-min interval
    const minutes = date.getMinutes() < 30 ? '00' : '30';
    return `${hours}:${minutes}`;
  } else {
    // Hour layout: always round down to the hour
    return `${hours}:00`;
  }
};

/**
 * Select unassigned ALT pickups for a specific time slot based on their pickUpTime
 * Respects the current layout mode (30-min vs hour)
 */
export const selectAltPickupsByTimeSlot = (timeSlot) => (state) => {
  if (!state?.timelineData?.taskList) return [];

  const thirtyMinLayout = state?.timelineControl?.thirtyMinLayout ?? true;

  return state.timelineData.taskList.filter((task) => {
    // Must be an unassigned ALT pickup
    if (!task.isALTPickUp) return false;
    if (task.isGateRelocation) return false;
    if (task.employeeId != null && task.employeeId !== undefined) return false;

    // Check if pickUpTime matches this slot (using current layout mode)
    const slot = timestampToSlot(task.pickUpTime, thirtyMinLayout);
    return slot === timeSlot;
  });
};

/**
 * Select unassigned gate relocations for a specific time slot based on their pickUpTime
 * Respects the current layout mode (30-min vs hour)
 */
export const selectGateRelocationsByTimeSlot = (timeSlot) => (state) => {
  if (!state?.timelineData?.taskList) return [];

  const thirtyMinLayout = state?.timelineControl?.thirtyMinLayout ?? true;

  return state.timelineData.taskList.filter((task) => {
    // Must be an unassigned gate relocation
    if (!task.isGateRelocation) return false;
    if (task.employeeId != null && task.employeeId !== undefined) return false;

    // Check if pickUpTime matches this slot (using current layout mode)
    const slot = timestampToSlot(task.pickUpTime, thirtyMinLayout);
    return slot === timeSlot;
  });
};

// selects gate relocation jobs that have not been assigned to any employee and need to be shown in the job list
// filtered by flight id to avoid rerendering the same gate relocation jobs for the same flight
export const selectGateRelocationJobList = (flightNumber) => (state) => {
  if (state?.timelineData.timelineData == undefined || state.timelineData.timelineData == null || state.timelineData.taskList == null) {
    return [];
  }

  let tasks = [...state.timelineData.taskList]; // list of tasks

  // get all gate relocation tasks that are not assigned to any employee
  let gateRelocationTasks = tasks.filter((task) => task.isGateRelocation == true && (task.employeeId == null || task.employeeId == undefined));

  // return gate relocation tasks filtered by flight number
  return gateRelocationTasks.filter((task) => task.flightInformation?.flightNumber == flightNumber);
}

// delete task
export const selectDeleteTaskStatus = (state) =>
  state.timelineData.unplanTaskStatus;
export const selectDeleteTaskError = (state) =>
  state.timelineData.unplanTaskError;

// create task
export const selectCreatedTask = (state) => state.timelineData.createdTask;
export const selectCreateTaskStatus = (state) =>
  state.timelineData.createTaskStatus;
export const selectCreateTaskError = (state) =>
  state.timelineData.createTaskError;

// bookings
export const selectBookings = (state) => {
  if (
    state.timelineData.bookings == undefined ||
    state.timelineData.bookings == null ||
    state.timelineData.bookings.length == undefined ||
    state.timelineData.bookings.length == 0
  ) {
    return [];
  }

  let bookings = [...state.timelineData.bookings];
  let tempList = [];
  let taskList = [...state.timelineData.taskList];

  bookings.forEach((booking) => {
    // Check if booking is already in task list
    if (
      booking.doc &&
      !taskList.some((task) => task["_id"] === booking.doc["_id"])
    ) {
      tempList.push(booking.doc);
    }
  });

  return tempList;
};

export const selectAllBookings = (state) => {
  if (
    state.timelineData.bookings == undefined ||
    state.timelineData.bookings == null ||
    state.timelineData.bookings.length == undefined ||
    state.timelineData.bookings.length == 0 ||
    state.timelineData.departureBookings == undefined ||
    state.timelineData.departureBookings == null ||
    state.timelineData.departureBookings.length == undefined ||
    state.timelineData.departureBookings.length == 0
  ) {
    return [];
  }

  let arrivals = [...state.timelineData.bookings];
  let departures = [...state.timelineData.departureBookings];
  let tempList = [];

  arrivals.forEach((booking) => {
    if (booking.doc) {
      tempList.push(booking.doc);
    }
  });

  departures.forEach((booking) => {
    if (booking.doc) {
      tempList.push(booking.doc);
    }
  });

  return tempList;
};


// Base selector for timeline data
const selectTimelineDataState = state => state.timelineData;

// OPTIMIZED: Memoized selectors for post booking list
export const selectPostedBookingsStatus = createSelector(
  [selectTimelineDataState],
  (timelineData) => timelineData.bookingListStatus
);

export const selectPostBookingListError = createSelector(
  [selectTimelineDataState],
  (timelineData) => timelineData.postBookingListError
);

export const selectBookingList = createSelector(
  [selectTimelineDataState],
  (timelineData) => timelineData.bookingList
);
export const selectAdditionalPassengers = state => state.bookings.additionalPassengers;

export const selectFlightAnalytics = (state) => {
  if (
    state.timelineData.bookings == undefined ||
    state.timelineData.bookings == null ||
    state.timelineData.bookings.length == undefined ||
    state.timelineData.bookings.length == 0
  ) {
    return {};
  }
  if (
    state.timelineData.timelineData == undefined ||
    state.timelineData.timelineData == null ||
    state.timelineData.timelineData.columnIds == undefined
  ) {
    return {};
  }

  // loop through bookings and create flight analytics dictionary
  let bookings = [...state.timelineData.bookings]; // list of all bookings for today
  let flightAnalytics = {}; // flight analytics dictionary

  bookings.forEach((booking) => {
    let currentBooking = booking.doc;
    let flightNumber =
      currentBooking.flightConfirmationDetails.carrierCode +
      currentBooking.flightConfirmationDetails.flightNumber;
  });

  // loop through tasks and add assigned count to each flight
  let taskList = [...state.timelineData.taskList];
  taskList.forEach((task) => {
    let flightNumber = task.flightInformation.flightNumber;
    if (flightAnalytics[flightNumber] != undefined) {
      flightAnalytics[flightNumber].assigned += 1;
    }
  });

  return flightAnalytics;
};

export const selectBookingsByFlight = (state, showAll = false) => {
  if (["PUJ", "DUB", "BFS", "JER", "MLA"].includes(state.user.dbInfo.details.authority)) {
    return {};
  }
  if (
    (state.timelineData.bookings == undefined || state.timelineData.bookings == null || state.timelineData.bookings.length == undefined || state.timelineData.bookings.length == 0) &&
    (state.timelineData.departureBookings == undefined || state.timelineData.departureBookings == null || state.timelineData.departureBookings.length == undefined || state.timelineData.departureBookings.length == 0)
  ) {
    return {};
  }
  if (state.timelineData.timelineData == undefined || state.timelineData.timelineData == null || state.timelineData.timelineData.columnIds == undefined
  ) {
    return {};
  }
  //#region selector calls
  const iata = state.user.dbInfo.details.authority;

  // get arrival / departure bookings 
  let arrivalBooking = Array.isFullArray(state?.timelineData?.bookings) ? [...sortJobsByAssistance(state?.timelineData?.bookings)] : [];
  let departureBookings = Array.isFullArray(state?.timelineData?.departureBookings) ? [...sortJobsByAssistance(state?.timelineData?.departureBookings)] : [];



  // check if the logeed user is a Saudi airport remove all departure bookings from SITA
  if (SaudiDomesticAirports?.includes(iata)) {
    // departureBookings = departureBookings?.filter((row) => row?.doc?.userId !== "SITA")

    // filter bookings by flight type (domestic,international,all)
    if (state?.timelineData?.flightsType !== "all") {
      if (state?.timelineData?.flightsType == "domestic") {
        arrivalBooking = arrivalBooking?.filter((item) => SaudiDomesticAirports.includes(item?.doc?.flightConfirmationDetails?.origin));
        departureBookings = departureBookings?.filter((item) => SaudiDomesticAirports.includes(item?.doc?.flightConfirmationDetails?.destination));
      }
      if (state?.timelineData?.flightsType == "international") {
        arrivalBooking = arrivalBooking?.filter((item) => !SaudiDomesticAirports.includes(item?.doc?.flightConfirmationDetails?.origin));
        departureBookings = departureBookings?.filter((item) => !SaudiDomesticAirports.includes(item?.doc?.flightConfirmationDetails?.destination));
      }
    }

    // check if selected time line is a holding area only show transit bookings
    if (state?.timelineAreas?.selectedTimeline?.holdingArea == true) {
      departureBookings = departureBookings?.filter((row) => row?.doc?.isTransitBooking == true);
      arrivalBooking = arrivalBooking?.filter((row) => row?.doc?.isTransitBooking == true);
    }
  }

  // get arrival / departure flights if we need to use the time from them
  let arrivalFlights = Array.isFullArray(state.flightInformationList.inboundFlights) ? state.flightInformationList.inboundFlights : [];
  let departureFlights = Array.isFullArray(state.flightInformationList.outboundFlights) ? state.flightInformationList.outboundFlights : [];
  if (!["JER", "DUB", "ORK", "BFS", "SNN", "PUJ", "MLA", "EDI", "SNN"].includes(iata)) {
    arrivalFlights = formatFlightListFromBookings(arrivalBooking, iata, getDate(state.timelineControl.timelineDate));
    departureFlights = formatFlightListFromBookings(departureBookings, iata, getDate(state.timelineControl.timelineDate));
  }
  arrivalBooking = processMissingBookingsTimes(arrivalFlights, arrivalBooking, "arrivals")
  departureBookings = processMissingBookingsTimes(departureFlights, departureBookings, "departures");

  // state task list 
  let taskList = Array.isFullArray(state?.timelineData?.taskList) ? [...state?.timelineData?.taskList] : [];

  // get airport locations list
  let locationsList = Array.isFullArray(state.timelineAreas.airportLocations) ? state.timelineAreas.airportLocations : [];
  //#endregion

  let tempList = {}; // temp list for holding flight dictionary

  //#region departures
  // check if bookingType filter includes departures or checkedIn or all add the departure bookings to tempList
  if (Array.isFullArray(departureBookings)) {
    let tempDepartures = [...departureBookings];
    // check if bookingType filter includes checkedIn filter departureBooking to only bookings that have paxPositionInfo

    //#region duplicates
    if (Array.isFullArray(state?.timelineData?.duplicatedDeparturesBookings)) {
      // get the duplicated departures bookings for the selected timeline date and add them to the tempDepartures
      let duplicatedDepartures = state.timelineData.duplicatedDeparturesBookings?.filter((duplicate) => duplicate?.doc?.flightConfirmationDetails?.departureDate == getDate(state?.timelineControl?.timelineDate));
      if (Array.isFullArray(duplicatedDepartures)) tempDepartures = [...tempDepartures, ...duplicatedDepartures]
    };
    //#endregion

    //#region boarding
    // check if preBoard is switched on 
    if (state.timelineControl.preBoard) {
      // create combined departure bookings from the departureBookings 
      let combinedDepartureBooking = createCombinedBookings(departureBookings);
      if (Array.isFullArray(combinedDepartureBooking)) tempDepartures = [...tempDepartures, ...combinedDepartureBooking];
      // filter duplicatedCombinedBookings departureDate to equal the selected timeline date and not show the ones that is for the same flight number but different date
      let duplicatedCombinedDepartures = state.timelineData.duplicatedCombinedBookings?.filter((duplicate) => duplicate?.doc?.flightConfirmationDetails?.departureDate == getDate(state?.timelineControl?.timelineDate));
      if (Array.isFullArray(duplicatedCombinedDepartures) && Array.isFullArray(combinedDepartureBooking) && Array.isFullArray(departureBookings)) {
        duplicatedCombinedDepartures = formatDuplicatedBoardings(duplicatedCombinedDepartures, departureBookings)
      }
      if (Array.isFullArray(duplicatedCombinedDepartures)) tempDepartures = [...tempDepartures, ...duplicatedCombinedDepartures];

    };
    //#endregion

    // //check if bookingType filter includes checkedIn filter only, filter departureBooking to only bookings that have paxPositionInfo activity checked in

    if (!state?.timelineAreas?.bookingType?.some(type => ["all", "departures"].includes(type)) && state?.timelineAreas?.bookingType?.some(type => ["checkedIn"].includes(type))) {
      tempDepartures = tempDepartures?.filter((booking) => (booking?.doc?.paxPositionInfo?.activity && booking?.doc?.paxPositionInfo?.activity == 'Checked-in') || (booking?.doc?.combinedBooking));
      // departureBookings = departureBookings?.filter((booking) => booking?.doc?.paxPositionInfo?.activity && booking?.doc?.paxPositionInfo?.activity == 'Checked-in');
    }

    // check if tempDepartures is an array with length
    if (Array.isFullArray(tempDepartures)) {
      // loop through tempDepartures bookings and create flight dictionary
      // made up of departures bookings that are not already on the timeline (not in timeline jobs or task list)
      processBookingsToTempList({
        thirtyMinLayout: state?.timelineControl?.thirtyMinLayout,
        tempList: tempList,
        bookings: tempDepartures,
        flightType: "departures",
        flightsData: departureFlights,
        taskList: taskList,
        preBoard: state.timelineControl.preBoard,
        iata: iata,
        bookingSearch: state.timelineData.bookingSearch,
        showAll,
        bookingType: state.timelineAreas.bookingType
      })
    }
  };

  //#endregion

  //#region arrivals
  // check if the bookingType filter includes  arrivals or all 
  if (Array.isFullArray(arrivalBooking)) {

    let tempArrivals = [...arrivalBooking];

    //#region duplicates
    // get the arrivals bookings that has duplicateCount in it 
    let duplicatedBookings = arrivalBooking?.filter((booking) => booking?.doc?.duplicateCount);
    let duplicatedArrivals = []; // array for the duplicated arrivals
    if (Array.isFullArray(duplicatedBookings)) {
      duplicatedBookings?.forEach((pax) => {
        // if 
        if (pax?.doc?.duplicateCount) createDuplicates(pax?.doc, duplicatedArrivals)
      });
    }
    if (Array.isFullArray(duplicatedArrivals)) tempArrivals = [...tempArrivals, ...duplicatedArrivals];
    //#endregion


    // remove passenger info fields from booking by creating new object using booking info
    tempArrivals = createArrivalBookingsList(tempArrivals, iata, arrivalFlights);

    //#region ramp arrivals
    // check if rampBookings switch is turned on && locationsList and arrivalFlights are arrays with length
    if (state.timelineControl.rampBookings && Array.isFullArray(locationsList) && Array.isFullArray(arrivalFlights)) {
      let rampLocationsList = [];  // list of airport locations gates and stands that are ramps

      // create an array of gates and stands
      locationsList.forEach((location) => {
        // check if location is a ramp
        if (location?.paxBoardType === "ramp") {
          if (location.gate != undefined && location.gate != '') {
            rampLocationsList.push(location.gate);
          }
          if (location.stand != undefined && location.stand != '') {
            rampLocationsList.push(location.stand);
          }
        }
      });

      let rampBookings = [];   // list of arrival ramp bookings(the stand or gate is ramp)
      let combinedRampBookings = []; // list of combined ramp bookings

      // check if the switch for ramp bookings for all locations is turned on make the rampBookings array equal to the tempArrivals array
      if (state.timelineControl.rampBookingsForAllLocations) {
        rampBookings = Array.isFullArray(tempArrivals) ? [...tempArrivals] : [];
      } else {
        // if the switch for ramp bookings for all locations is turned off loop through the tempArrivals array and add the bookings to the rampBookings array if the gate or stand is in the rampLocationsList
        for (let i = 0; i < tempArrivals?.length; i++) {
          let booking = tempArrivals[i];
          let bookingDoc = booking?.doc;
          // get the flight number out of booking doc
          const bookingFlightNumber = bookingDoc?.originalBookingDoc?.flightConfirmationDetails?.carrierCode && bookingDoc?.originalBookingDoc?.flightConfirmationDetails?.flightNumber
            ? `${bookingDoc?.originalBookingDoc?.flightConfirmationDetails?.carrierCode}${bookingDoc?.originalBookingDoc?.flightConfirmationDetails?.flightNumber}`
            : "";

          // get the booking flight from inboundFlights
          const selectedFlight = arrivalFlights?.find((flight) => flight?.flightNumber == bookingFlightNumber)

          if (selectedFlight && !bookingDoc?._id?.includes("-part") && (rampLocationsList?.includes(selectedFlight?.gate) || rampLocationsList?.includes(selectedFlight?.stand))) {
            // if the rampLocationsList includes the gate or the stand of the selectedFlight add it to rampBookings array
            rampBookings.push(booking);
          };
        };

      }

      // check if rampBookings is an array and has length
      if (Array.isFullArray(rampBookings)) {
        // need to create combined ramp bookings, group passengers by flight number into a list
        combinedRampBookings = createCombinedRampBookings(rampBookings, state.timelineControl.rampBookingsForHCAndHS);
      };

      // check if the duplicatedCombinedRampBookings is an array with length add it to the combinedRampBookings
      if (Array.isFullArray(state.timelineData.duplicatedCombinedRampBookings)) {
        // filter duplicatedCombinedRampBookings arrivalTime to equal the selected timeline date 
        let tempDuplicates = state.timelineData.duplicatedCombinedRampBookings?.filter((duplicate) => getDate(duplicate?.doc?.flightConfirmationDetails?.arrivalTime) == getDate(state?.timelineControl?.timelineDate));
        let filteredDuplicates = [];
        if (Array.isFullArray(tempDuplicates)) filteredDuplicates = [...tempDuplicates];
        combinedRampBookings = Array.isFullArray(combinedRampBookings) ? [...combinedRampBookings, ...filteredDuplicates] : [...filteredDuplicates]
      };

      // check if the final combinedRampBookings is an array with length
      if (Array.isFullArray(combinedRampBookings)) {
        tempArrivals = [...combinedRampBookings, ...tempArrivals];
      }
    }
    //#endregion

    if (Array.isFullArray(tempArrivals)) {
      if (!state?.timelineAreas?.bookingType?.some(type => ["all", "arrivals"].includes(type))) {
        tempArrivals = tempArrivals?.filter((booking) => !booking?.doc?.flightBooking)
      }
      if (!state?.timelineAreas?.bookingType?.some(type => ["all", "ramp"].includes(type))) {
        tempArrivals = tempArrivals?.filter((booking) => !booking?.doc?.combinedRampBooking)
      }

      // loop through tempArrivals bookings and create flight dictionary
      // made up of arrivals bookings that are not already on the timeline (not in timeline jobs or task list)
      processBookingsToTempList({
        thirtyMinLayout: state?.timelineControl?.thirtyMinLayout,
        tempList: tempList,
        bookings: tempArrivals,
        flightType: "arrivals",
        flightsData: arrivalFlights,
        taskList: taskList,
        preBoard: state.timelineControl.preBoard,
        iata: iata,
        bookingSearch: state.timelineData.bookingSearch,
        showAll

      })
    }
  }
  //#endregion

  //#region ALT pickups

  // check if the ALTPickUpTaskList is an array and length > 0 and the selected timeline area has departures
  if (state.timelineAreas.bookingType?.includes("all") || state.timelineAreas.bookingType?.includes("departures") || state.timelineAreas.bookingType?.includes("ALTPickUp")) {

    // alternative pick up tasks list
    let ALTPickUpTaskList = Array.isFullArray(state.timelineData.taskList) ? state.timelineData.taskList?.filter((element) => element?.isALTPickUp == true) : [];

    if (Array.isFullArray(ALTPickUpTaskList)) {
      let ALTPickUpFlights = Array.isFullArray(departureFlights) ? [...departureFlights] : [];
      if (Array.isFullArray(ALTPickUpTaskList)) {
        ALTPickUpFlights = [...ALTPickUpFlights, ...groupAndFormatALTPickupTasks(Array.isFullArray(ALTPickUpTaskList) ? ALTPickUpTaskList?.filter((element) => element?.pickUpTime) : [])];
      }

      processBookingsToTempList({
        thirtyMinLayout: state?.timelineControl?.thirtyMinLayout,
        tempList: tempList,
        bookings: ALTPickUpTaskList,
        flightType: "departures",
        flightsData: ALTPickUpFlights,
        taskList: taskList,
        preBoard: state.timelineControl.preBoard,
        iata: iata,
        isALTPickUp: true,
        departureBookings: departureBookings,
        bookingSearch: state.timelineData.bookingSearch,
        showAll

      });
    }
  }


  //#endregion
  let flightKeys = Object.keys(tempList);
  let timeKeys = [];

  // for each flight list
  flightKeys.forEach((flight) => {

    // 
    const booking = tempList[flight][0];
    if (!booking) return;

    //check booking type, then get time depend on arrival/departure live flight feed.
    const type = booking?.flightConfirmationDetails?.destination === iata ? "arrival" : "departure";

    let bookingTime = null;

    if (type === "departure") {
      bookingTime = Array.isFullArray(departureFlights) && ["JER", "DUB", "ORK", "BFS", "SNN", "PUJ", "MLA", "EDI", "SNN"].includes(iata)
        ? getFlightTime(departureFlights, `${booking?.flightConfirmationDetails?.carrierCode}${booking?.flightConfirmationDetails?.flightNumber}`)
        : booking?.flightConfirmationDetails.departureTime || booking?.flightConfirmationDetails.arrivalTime;
    } else {
      bookingTime = Array.isFullArray(arrivalFlights) && ["JER", "DUB", "ORK", "BFS", "SNN", "PUJ", "MLA", "EDI", "SNN"].includes(iata)
        ? getFlightTime(arrivalFlights, `${booking?.flightConfirmationDetails?.carrierCode}${booking?.flightConfirmationDetails?.flightNumber}`)
        : booking?.flightConfirmationDetails.departureTime || booking?.flightConfirmationDetails.arrivalTime;
    }

    if (bookingTime) {
      timeKeys.push({ time: bookingTime, flight: flight });
    }
  });

  timeKeys.sort(function (a, b) {
    var c = new Date(a.time).getTime(); // Convert to milliseconds
    var d = new Date(b.time).getTime(); // Convert to milliseconds
    return c - d; // Sort in ascending order (earliest first)
  });

  let newTemp = {};
  timeKeys.forEach((timeKey) => {
    newTemp[timeKey.flight] = tempList[timeKey.flight];
  });


  return newTemp;
};

const convertToHourString = (isoString) => {
  const date = new Date(isoString); // Parse the ISO string into a Date object
  const hours = date.getUTCHours().toString().padStart(2, '0'); // Get hours and pad with 0 if needed
  const minutes = '00'; // Fixed minutes as 00
  return `${hours}:${minutes}`;
};


// search term
export const selectBookingSearch = (state) => state.timelineData.bookingSearch;
export const selectBookingSearchFilter = (state) => state.timelineData.bookingSearchFilter;

// bookings
export const selectGetArrivalBookingsStatus = (state) => state.timelineData.bookingStatus;
export const selectGetDepartureBookingStatus = (state) => state.timelineData.departureBookingStatus;

export const selectBookingsError = (state) => state.timelineData.bookingError;

// timeline
export const {
  setAdditionalPassengers,
  resetAdditionalPassengers,
  updateTaskList,
  resetTimelineToCache,
  reset,
  setTimelineData,
  resetTimelineData,
  resetBookings,
  clearCreateTaskStatus,
  setTimelineCache,
  resetDeleteFlags,
  setFlightsTypeFilter,
  resetUpdateTaskFlags,
  setBookingSearch,
  setBookingSearchFilter,
  getBookingByFlightNum,
  resetBookingByFlightNum,
  updateArrivalsTaskList,
  updateDeparturesTaskList,
  updateBreakTaskList,
  updateAdhocTaskList,
  resetPaxCheckInFlags,
  resetPaxCheckOutFlags,
  resetArrivalPaxCheckInFlags,
  resetSetBookingLocationFlags,
  resetToggleCheckInPauseFlags,
  updateTimeLineDepartureBookings,
  updateTimeLineArrivalsBookings,
  setDuplicatedCombinedBookings,
  setDuplicatedCombinedRampBookings,
  setDuplicatedDepartureBookings,
  setDuplicatedArrivalsBookings,
  resetDeleteBookingFlags,
  resetUnRejectPaxFlags,
  resetGetPreAdvisedAndWalkupsStatus,
  setTaskStatusFilter,
  resetGetPreAdvisedAndWalkups,
  setPreAdvisedAndWalkupsReportData,
  resetSelectPassengersFlags,
  resetDeleteTimelineJobFlags,
  setShowAddPassenger
} = timelineDataSlice.actions;

export const selectDuplicatedCombinedBookings = (state) => state.timelineData.duplicatedCombinedBookings;
export const selectDuplicatedCombinedRampBookings = (state) => state.timelineData.duplicatedCombinedRampBookings;
export const selectDuplicatedDeparturesBookings = (state) => state.timelineData.duplicatedDeparturesBookings;
export const selectDuplicatedArrivalsBookings = (state) => state.timelineData.duplicatedArrivalsBookings;

// cache
export const selectTimelineCache = (state) => state.timelineData.timelineCache;
export const selectLatestJob = (state) => state.timelineData.newestJob;

// task list
export const selectTaskList = (state) => state.timelineData.taskList;
export const selectTaskStatus = (state) => state.timelineData.taskStatus;

// Select tasks grouped by flight number
export const selectTasksByFlight = (flightNumber) => (state) => {
  if (!state.timelineData.taskList || !Array.isArray(state.timelineData.taskList)) {
    return [];
  }

  // Filter tasks by flight number
  return state.timelineData.taskList.filter(task => {
    // Get flight number from task - try multiple possible locations
    const taskFlightNumber = task?.flightInformation?.flightNumber ||
      (task?.flightInformation?.carrierCode && task?.flightInformation?.flightNumber
        ? `${task.flightInformation.carrierCode}${task.flightInformation.flightNumber}`
        : null);

    return taskFlightNumber === flightNumber;
  });
};
export const selectAcceptUnplanedTaskStatus = (state) => state.timelineData.acceptUnplanedTaskStatus;
export const selectAcceptUnplanedTaskError = (state) => state.timelineData.acceptUnplanedTaskError;
export const selectFlightsType = (state) => state.timelineData.flightsType;
export const selectUpdateTaskStatus = (state) => state.timelineData.updateTaskStatus;
export const selectBookingByFlightNum = (state) => {
  if (Array.isFullArray(state.timelineData.bookingByFlightNum)) {
    return state.timelineData.bookingByFlightNum?.[0]?.doc
  } else return null
}
export const selectArrivalsTaskList = (state) => state.timelineData.arrivalsTaskList;
export const selectDeparturesTaskList = (state) => state.timelineData.departuresTaskList;
export const selectBreakTaskList = (state) => state.timelineData.breakTaskList;
export const selectAdhocTaskList = (state) => state.timelineData.adhocTaskList;
export const selectTimelineArrivalsBookingList = (state) => state?.timelineData?.bookings;
export const selectTimelineDeparturesBookingList = (state) => state?.timelineData?.departureBookings;
export const selectTimelineALTPickUpList = (state) => {
  if (!Array.isFullArray(state.timelineData.taskList)) return []
  let tempList = state.timelineData.taskList?.filter((task) => task?.isALTPickUp == true)
  return Array.isFullArray(tempList) ? tempList : []
};
export const selectPaxCheckInStatus = (state) => state?.timelineData?.paxCheckInStatus;
export const selectPaxCheckOutStatus = (state) => state?.timelineData?.paxCheckOutStatus;
export const selectArrivalPaxCheckInStatus = (state) => state?.timelineData?.arrivalPaxCheckInStatus;

export const selectSetBookingLocationStatus = (state) => state?.timelineData?.setBookingLocationStatus;
export const selectToggleCheckInPauseStatus = (state) => state?.timelineData?.toggleCheckInPauseStatus;
export const selectCheckInPausedBookings = (state) => state?.timelineData?.checkInPausedBookings;
export const selectDeleteBookingStatus = (state) => state?.timelineData?.deleteBookingStatus;
export const selectUnRejectPaxStatus = (state) => state?.timelineData?.unRejectPaxStatus;
export const selectGetPreAdvisedAndWalkupsStatus = (state) => state?.timelineData?.getPreAdvisedAndWalkupsStatus;
export const selectPreAdvisedAndWalkups = (state) => state?.timelineData?.preAdvisedAndWalkups;
export const selectPreAdvisedAndWalkupsReportData = (state) => state?.timelineData?.preAdvisedAndWalkupsReportData;

export const selectSelectPassengersStatus = (state) => state?.timelineData?.selectPassengersStatus;
export const selectTaskStatusFilter = (state) => state?.timelineData?.taskStatusFilter;
export const selectDeleteTimelineJobStatus = (state) => state?.timelineData?.deleteTimelineJobStatus;
export const selectShowAddPassenger = (state) => state?.timelineData?.showAddPassenger;

export default timelineDataSlice.reducer;
